// External modules
import acHTTPClient from 'services/ACHTTPClient';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';
import { onAuthError } from '../auth';

let limit = config.limit.providers;

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;
const userAPIURL = config.userAPIURL;
// const userAPIURL='http://localhost:8150';

const getProvidersError = error => {
  return {
    type: constants.GET_PROVIDERS_ERROR,
    error,
  };
};

const getProvidersSuccess = providers => {
  return {
    type: constants.GET_PROVIDERS_SUCCESS,
    providers: providers,
  };
};

const getProviders = filterParams => {
  let apiURL = `${experienceAPIURL}/providers?limit=${limit}`;
  if (filterParams) {
    apiURL += '&' + filterParams.slice(1); // Remove extra & from the filter string
  }
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getProvidersError(response.statusText));
        }
        dispatch(getProvidersSuccess(response.data));
      })
      .catch(error => {
        dispatch(getProvidersError(error));
      });
  };
};

const getProviderError = error => {
  return {
    type: constants.GET_PROVIDER_ERROR,
    error,
  };
};

const getProviderSuccess = provider => {
  return {
    type: constants.GET_PROVIDER_SUCCESS,
    provider: provider,
  };
};

const getProvider = id => {
  let apiURL = `${experienceAPIURL}/providers/${id}`;
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getProviderError(response.statusText));
        }
        dispatch(getProviderSuccess(response.data));
      })
      .catch(error => {
        dispatch(getProviderError(error));
      });
  };
};

const postProviderError = error => {
  return {
    type: constants.POST_PROVIDER_ERROR,
    error,
  };
};

const postProviderSuccess = provider => {
  return {
    type: constants.POST_PROVIDER_SUCCESS,
    provider: provider,
  };
};

const postProvider = newProvider => {
  let apiURL = `${experienceAPIURL}/providers`;
  return dispatch => {
    const config = { url: apiURL, method: 'POST', data: newProvider };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(postProviderError(response.statusText));
        }
        dispatch(postProviderSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(postProviderError(error));
      });
  };
};

const postCloneProviderError = error => {
  return {
    type: constants.POST_CLONE_PROVIDER_ERROR,
    error,
  };
};

const postCloneProviderSuccess = providerId => {
  return {
    type: constants.POST_CLONE_PROVIDER_SUCCESS,
    provider: providerId,
  };
};

const postCloneProvider = (srcProvider,optFilterParams) => {
  let apiURL = `${experienceAPIURL}/providers/${srcProvider.id}/clone`;
  return dispatch => {
    const config = { url: apiURL, method: 'POST', data: srcProvider };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(postCloneProviderError(response.statusText));
        }
        dispatch(postCloneProviderSuccess(response.data));
        // refresh the provider list to inclue the new clone
        dispatch(getProviders(optFilterParams));
        const url = new URL(window.location);
        url.searchParams.set('id', response.data?.data?.id);
        window.history.pushState({}, '', url);
        window.location.reload();
      })
      .catch(error => {
        onAuthError(error);
        dispatch(postCloneProviderError(error));
      });
  };
};

const patchProviderError = error => {
  return {
    type: constants.PATCH_PROVIDER_ERROR,
    error,
  };
};

const patchProviderSuccess = provider => {
  return {
    type: constants.PATCH_PROVIDER_SUCCESS,
    provider: provider,
  };
};

const patchProvider = provider => {
  let apiURL = `${experienceAPIURL}/providers/${provider.id}`;
  return dispatch => {
    const config = { url: apiURL, method: 'PATCH', data: provider };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(patchProviderError(response.statusText));
        }
        dispatch(patchProviderSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(patchProviderError(error));
      });
  };
};

const patchProviderNote = (providerId, note) => {
  let apiURL = `${experienceAPIURL}/providers/${providerId}/notes`;
  return dispatch => {
    const config = { url: apiURL, method: 'PATCH', data: note };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(patchProviderError(response.statusText));
        }
        dispatch(patchProviderSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(patchProviderError(error));
      });
  };
};

const putPOISError = error => {
  return {
    type: constants.PUT_POIS_ERROR,
    error,
  };
};

const putPOISSuccess = pois => {
  return {
    type: constants.PUT_POIS_SUCCESS,
    pois: pois,
  };
};

const putPOIs = (providerId, newPOI) => {
  let apiURL = `${experienceAPIURL}/providers/${providerId}/pois`;
  return dispatch => {
    const config = { url: apiURL, method: 'PUT', data: newPOI };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(putPOISError(response.statusText));
        }
        dispatch(putPOISSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(putPOISError(error));
      });
  };
};

const getLinkedUsersError = error => {
  return {
    type: constants.LINKED_USERS_ERROR,
    error,
  };
};

const getLinkedUsersSuccess = data => {
  return {
    type: constants.LINKED_USERS_SUCCESS,
    data: data,
  };
};


const getProviderLinkedUser = (providerId) => {
  let apiURL = `${userAPIURL}/api/v1/users/${providerId}`;
  return dispatch => {
    const config = { url: apiURL, method: 'GET'};
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getLinkedUsersError(response.statusText));
        }
        dispatch(getLinkedUsersSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(getLinkedUsersError(error));
      });
  };
};


const deleteProviderLinkedUser =(providerId,userDetails)=>{
  let apiURL = `${userAPIURL}/api/v1/users/${providerId}/linked-user/${userDetails.id}`;
  return dispatch => {
    const config = { url: apiURL, method: 'POST',data: {authId:userDetails.auth0_id}};
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getLinkedUsersError(response.statusText));
        }
        dispatch(getLinkedUsersSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(getLinkedUsersError(error));
      });
  };
}



export { getProviders, getProvider, postProvider, postCloneProvider, patchProvider, patchProviderNote, putPOIs,getProviderLinkedUser,deleteProviderLinkedUser};
